import React, {Component} from "react";
import Home from "../../../images/home.jpg";
import projectData from "./projectData";
import ProjectCard from "./previousProjectCard";
import { Link } from "react-router-dom";
 

class PreviousProject extends Component{

    constructor(props){
        super(props);
        this.state = {
            sliceLimit : 6,
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <div className="flex-title">
                    <h1>Previous projects</h1>
                    <h4 className="prim-txt">
                        <Link to="previous-projects">
                            View more projects
                        </Link>
                    </h4>
                </div>
                <div className="project-widget">
                    {projectData.slice(0, this.state.sliceLimit).map((item) => <ProjectCard key={item.id} name={item.name} desc={item.desc} />)}
                </div>
            </div>
        );
    }
}

export default PreviousProject;